/* eslint-disable */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable no-loop-func */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable quote-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import axios from 'axios';
import Tour from 'reactour';
import { Redirect } from 'react-router';
import Popup from 'reactjs-popup';


import {CopyToClipboard} from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import QuickActionModal from '../../components/Modals/QuickActionModal/QuickActionModal';
import Classes from './ShareScreen.css';
import Aux from '../../hoc/Aux';
import OnlineSongManager from '../../components/OnlineSongManager/OnlineSongManager';
import socket from '../../SocketManager';
import NextSong from '../../components/NextSong/NextSong';
import MConfig from '../../moramma-config.json';
import logger from '../../logger';
import helpers from '../../helpers/helpers';
import MenuPlaylistItem from '../../components/MenuPlaylistItem/MenuPlaylistItem';
import lang from '../../lang.json';
import DeezerPlayer from '../../components/OnlineSongManager/DeezerPlayerLarge';

class ShareScreen extends Component {
    state = {
        socket: {
            signature: 'nextsong-signature'
          },
        shareToken: '',
        copyDataTip: 'Clicca per copiare'
    }


    async componentDidMount() {
      const localtoken = localStorage.getItem('API');
      const shareJwt = localStorage.getItem('ShareAPI');
      if (!localtoken) {
        logger.error('[ManagerScreen|fetchUserData] Local token not found');
        this.logOut();
      }

      if(shareJwt) {
        this.setState({
          shareToken: shareJwt
        })
      }

      await axios({
        method: 'post',
        url: `${MConfig.BASE_API}/react/sharescreen/auth`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: { authToken: shareJwt }
      }).then(items => {
        localStorage.setItem('ShareAPI', items.data.token);
        if(items) {
          this.setState({
            shareToken: items.data.token
          })
        }  
      }).catch(err => {
        logger.error('[ManagerScreen|fetchUserData] Error during  API/react/sharescreen/auth', err);
      });
    }

    onCopyEvent = () => {
      this.setState({
        copyDataTip: 'Copiato negli appunti!'
      });
      ToastsStore.success('Copiato!');
    }

    startSocketListener = () => {

        socket.on('r-server-song-go-online', (payload) => {
            logger.error('ManagerScreen|r-server-song-go-online] Called');
            this.onNewSongHandler(payload.songs);
            this.setOnlineSong();
          });
    }

    txtSpotName = (e) =>{
        this.setState({ txtSpotName: e.target.value });
    }

    connectToSpot = () => {
        this.startSocketEvents(this.state.txtSpotName);
    }

    startSocketEvents = (room) => {
        // socket.connect();
        socket.on('connect', async () => {
          // console.error('scket', sockett.client.conn.server.clientsCount);
          logger.debug('[ManagerScreen|connect] Called');
          // remove 'disconnected from server' banner
          // Retrive spot status from API
          // await this.SocketResyncSpotStatus();   
        });    
  
        socket.emit('client-join-channel', { customId: this.state.socket.signature, room: room });
  
        // moved outside connect
        socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: room });
        // socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: this.state.roomName });
        
        logger.debug('[ManagerScreen|connect] SOCKET.IO react-subscribe-id');
        logger.debug('[ManagerScreen|connect] socket.io is connected');
  
        // wait ack
        // TODO: repace with jwt
        socket.on('server-ack-id-validation', () => {
          logger.debug('[ManagerScreen|server-ack-id-validation] Called');
          this.setState({ showblock: true });
        });
  

        socket.on('r-server-song-go-online', (payload) => {
          logger.error('ManagerScreen|r-server-song-go-online] Called');
          this.onNewSongHandler(payload.songs);
          
        });
  
       /* socket.on('client-connected-change', (payload) => {
          logger.debug('[NEXTSONG][componentDidMount() | client-connected-change] receive new data');
  
          if (payload.key === this.state.roomName) {
            this.setState({ connectedUsers: payload.value });
          }
        });*/
      }

      onNewSongHandler = (data) => {
        //console.log('onNewSongHandler data', data);
        
        data.forEach((el) => {
          if (el.type === 'onAir') {

            const index = data.findIndex(x => x.id === el.id);
  
            this.setState({ onlineSong: data[index] });
          }
        });
      }

    render() {
      return (
        <Aux>  
          <div className="container-fluid">
            <br/>
            <br/>
            <div className="d-flex flex-column align-items-center">
              <h5>Condividi con i tuoi amici questo link d'invito per permetterli di collegarsi al tuo spot!</h5>
              <p>Il link è valido per la durata di 1h, dopodichè cambierà.</p>
              <br />
              <br />
              <CopyToClipboard text={`https://player.moramma.com/cast?token=${this.state.shareToken}`}>
                <h5 data-tip={this.state.copyDataTip} onClick={this.onCopyEvent}><span className={Classes.Token} >{this.state.shareToken.substring(0, 50)}...&nbsp;&nbsp;<i class="fas fa-copy"></i>&nbsp;&nbsp;</span></h5> 
              </CopyToClipboard>
              <br/>
              <ReactTooltip/>
              <br />
              <p>Gli utenti esterni potranno usare il tuo link, oppure accedere tramite questa pagina: <span className={Classes.Link}>&nbsp;player.moramma.com/cast&nbsp;</span></p>
              <br />
            <br />
            <img src={require('../../assets/img/ic_share.png')} className={Classes.MainImg} />
            </div>
          </div>
          <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />  
        </Aux>
      );
    }
} 

export default ShareScreen;
